/**
 * Main entry point for the application
 * This file renders the root React component and sets up the Redux store
 * @module index
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './translation/index';
import App from './app';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import './styles.css';

/**
 * Root element where the React application is mounted
 * @type {ReactDOM.Root}
 */
const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * Render the main App component wrapped in the Redux Provider
 * StrictMode is commented out to avoid duplicate API calls during development
 */
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
